import React from 'react'
import style from './QuestionSimpleText.module.scss'
import TextMarkup from '../../../Modules/Ebook/Common/Exercise/components/TextMarkup/TextMarkup'

const QuestionSimpleText = (props) => (
  <TextMarkup>
    <div
      className={style.textBlock}
      dangerouslySetInnerHTML={{ __html: props.text }}
    />
  </TextMarkup>
)

export default QuestionSimpleText
